import React from 'react';

function SectionHeader({ title, align = 'center', accentColor = '#2563eb' }) {
  const alignmentClass = {
    'left': 'text-left',
    'center': 'text-center',
    'right': 'text-right'
  };

  return (
    <div className={`w-full ${alignmentClass[align]} mb-16`}>
      <div className="relative inline-block">
        <h2 className="text-4xl md:text-5xl font-normal text-gray-900 relative z-10">
          {title}
        </h2>
        
        {/* Accent bar */}
        <div 
          className="absolute -bottom-2 left-0 h-2 w-24 z-0"
          style={{ backgroundColor: accentColor }}
        ></div>
        
        {/* Subtle shadow text effect */}
        <h2 
          className="text-4xl md:text-5xl font-normal absolute top-0 left-0 text-transparent -z-10"
          style={{ WebkitTextStroke: '1px rgba(0,0,0,0.05)' }}
        >
          {title}
        </h2>
      </div>
    </div>
  );
}

export default SectionHeader;